import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const UnqueueFamilyMutation = graphql.persisted(
  "UnqueueFamily",
  graphql(`
    mutation UnqueueFamily($familyEnrollmentId: ID!) {
      unqueueFamily(input: {familyEnrollmentId: $familyEnrollmentId}) {
        familyEnrollment {
          id
          state
          inviteStatus
          canQueueForInvite
          canSendInvite
          queuedAt
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UnqueueFamilyMutation };

export function useUnqueueFamily() {
  return useMutation(UnqueueFamilyMutation);
}
